export default __webpack_public_path__ + "fbc736d8eef8aa0dc9f334d69368ab36.svg";